export const preloadBigBgWithThumbnail = (screen) => {
  let img = new Image()

  const bgContainers = document.getElementsByClassName('bgContainer')
  console.log(bgContainers, screen)
  const bgContainer = bgContainers[screen === 8 ? 0 : screen]
  console.log(bgContainer)
  // console.log(bgContainers)
  if (!bgContainer) return
  // Matchs the "url(...)"
  let bigBgSrc = bgContainer.style.backgroundImage.match(/url\((.+?)\)/i)
  console.log(bigBgSrc)
  if (bigBgSrc) {
    // Removes quotations
    bigBgSrc = bigBgSrc[1].replace(/'|"/g, '')
    // console.log(bigBgSrc)
    img.onload = function () {
      bgContainer.querySelector('.thumbnail').classList.add('thumbnail-hide')
    }
    img.src = bigBgSrc
  }
}
